// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xiM8","col":"styles_col__3WXXs"};